import { render, staticRenderFns } from "./DraggableTreeview.vue?vue&type=template&id=07b23272&scoped=true&"
import script from "./DraggableTreeview.vue?vue&type=script&lang=js&"
export * from "./DraggableTreeview.vue?vue&type=script&lang=js&"
import style0 from "./DraggableTreeview.vue?vue&type=style&index=0&id=07b23272&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b23272",
  null
  
)

export default component.exports